"use client";

import { useState } from "react";

import { Button } from "@/components/ui/button";

import type { BlogListItem as BlogListItemType } from "../types/blog.types";
import { BlogListItem } from "./blog-list-item";

const INITIAL_VISIBLE_POSTS = 20;
const LOAD_MORE_STEP = 20;

type BlogPostFeedProps = {
  posts: BlogListItemType[];
  initialVisiblePosts?: number;
  loadMoreStep?: number;
  enableLoadMore?: boolean;
  showImageCount?: number;
};

export function BlogPostFeed({
  posts,
  initialVisiblePosts = INITIAL_VISIBLE_POSTS,
  loadMoreStep = LOAD_MORE_STEP,
  enableLoadMore = true,
  showImageCount = 5,
}: BlogPostFeedProps) {
  const [visibleCount, setVisibleCount] = useState(initialVisiblePosts);

  const visiblePosts = posts.slice(0, visibleCount);
  const hasMorePosts = enableLoadMore && posts.length > visibleCount;

  return (
    <div>
      <section className="divide-y border-y pt-8">
        {visiblePosts.map((post, index) => (
          <BlogListItem
            key={post.slug}
            post={post}
            featured={index === 0}
            showImage={index < showImageCount}
          />
        ))}
      </section>

      {hasMorePosts ? (
        <div className="flex justify-center pt-10">
          <Button
            type="button"
            variant="outline"
            size="lg"
            onClick={() =>
              setVisibleCount((currentCount) => currentCount + loadMoreStep)
            }
          >
            Load more
          </Button>
        </div>
      ) : null}
    </div>
  );
}
